import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import HomeMain from "Components/Home/HomeMain";
// const HomeMain = React.lazy(() => import("Components/Home/HomeMain"));

const Home = ({ setCheckedChaseUp }) => {
  return (
    // <ContainerWrapper>
    <HomeMain setCheckedChaseUp={setCheckedChaseUp} />
    // </ContainerWrapper>
  );
};

export default Home;
